import { create } from "zustand"
import { createJSONStorage, persist } from "zustand/middleware"

import type { User } from "@/modules/types"

interface UserState {
  user: User | null
  setUser: (user: User) => void
  reset: () => void
  permissions: string
  setPermissions: (permissions: string) => void
  _hasHydrated: boolean
  setHasHydrated: (state: boolean) => void
}

export const useCurrentUser = create<UserState>()(
  persist(
    (set) => ({
      user: null,
      permissions: "",
      _hasHydrated: false,
      setHasHydrated: (state: boolean) => {
        set({ _hasHydrated: state })
      },
      reset: async () => {
        set({
          user: null
        })
      },
      setUser: async (user: User) => {
        set({
          user
        })
      },
      setPermissions: async (permissions: string) => {
        set({
          permissions
        })
      }
    }),
    {
      name: "user-storage",
      storage: createJSONStorage(() => window.localStorage),
      onRehydrateStorage: () => (state) => {
        state?.setHasHydrated(true)
      }
    }
  )
)
